import { render, staticRenderFns } from "./ModalSocios.vue?vue&type=template&id=3300ccb8&scoped=true"
import script from "./ModalSocios.vue?vue&type=script&lang=js"
export * from "./ModalSocios.vue?vue&type=script&lang=js"
import style0 from "./ModalSocios.vue?vue&type=style&index=0&id=3300ccb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300ccb8",
  null
  
)

export default component.exports